import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h1 } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.section `
  background-color: ${brand.beige};
`;
const ContentWrapper = styled.div `
  ${siteWide};
  ${baseGrid}

  gap: 24px;
  padding-top: ${fluid(32, 76)};
  padding-bottom: ${fluid(32, 76)};
`;
const ContentInner = styled.div `
  grid-column: 1 / span 12;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 8;
  }
`;
const Content = styled.div `
  ${contentStyles};

  p:last-child {
    margin-bottom: 0;
  }

  margin: 0 0 ${fluid(32, 40)};

  @media ${from(Device.TabletLarge)} {
    max-width: 530px;
  }
`;
const Title = styled.h2 `
  ${h1};
`;
const ImageWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 2 / span 10;

  @media ${from(Device.Tablet)} {
    grid-column: 9 / span 4;
    justify-content: flex-end;
  }
`;
const Image = styled.img `
  display: block;
  width: 100%;
`;
const FindNearestShowroomStyles = {
    Container,
    Content,
    ContentInner,
    ContentWrapper,
    Image,
    ImageWrapper,
    Title,
};
export default FindNearestShowroomStyles;
